var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3C3C3C",
    d: "M22.548 28.028v-2.74a5.48 5.48 0 0 0-5.48-5.48H7.48A5.48 5.48 0 0 0 2 25.289v2.74M11.59 12.96a5.48 5.48 0 1 0 0-10.96 5.48 5.48 0 0 0 0 10.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4E00",
    d: "m22.549 12.96 2.74 2.74 5.48-5.48"
  }))));
};
export default SvgUserIcon;